module.exports = __webpack_public_path__ + "img/first.fe6f7e73.png";